import { Component, Input, OnDestroy, OnInit } from "@angular/core";

import { Router } from "../../../../../node_modules/@angular/router";
import { HeaderService } from "../../../../views/services/header.service";
import { LandingService } from "../../../../views/services/landing.service";

@Component({
  selector: "app-completed",
  templateUrl: "./completed.component.html",
  styleUrls: ["./completed.component.css"]
})
export class CompletedComponent implements OnInit, OnDestroy {
  @Input() searchResult: any;
  @Input() searchClicked: boolean;
  public tableData: any = {};
  public days: number;

  constructor(
    private landingService: LandingService,
    public headerService: HeaderService,
    public router: Router
  ) { }

  ngOnInit() {
    this.tableData = [];
    if (this.searchClicked === true) {
      this.tableData = this.searchResult;
      if (this.tableData.length > 1) {
        this.processTableData(this.tableData);
      }
    } else {
      this.headerService.getSystemProperties().then(properties => {
        this.days = properties["NO_OF_DAYS_COMPlETED"];
        this.landingService
          .getCompletedInternalScreenData("completed", this.days, null)
          .subscribe(response => {
            this.tableData = response.body;
            this.processTableData(this.tableData);
          });
      });
    }
  }

  processTableData(tableData: any) {
    this.tableData.forEach(element => {
      if (element.REASONS) {
        element.REASONS = element.REASONS.replace(/\|/g, ",");
      }
      if (element.EXAMINEE_ACCOMMS) {
        element.EXAMINEE_ACCOMMS = element.EXAMINEE_ACCOMMS.replace(/\|/g, ",");
      }
    });
  }

  ngOnDestroy() { }

  sendStudentDetails(examinee: any) {
    const studentDetails = {
      personId: examinee.PERSON_ID,
      requestId: examinee.REQUEST_ID,
      consultantId: examinee.CONSULTANT_ID ? examinee.CONSULTANT_ID : "",
      taaPin: examinee.ACCOMMS_PIN ? examinee.ACCOMMS_PIN : "",
      organizationName: examinee.ORGANIZATION_NM
        ? examinee.ORGANIZATION_NM
        : "",
      firstNm: examinee.PNFIRSTNAME ? examinee.PNFIRSTNAME : "",
      lastNm: examinee.PNLASTNAME ? examinee.PNLASTNAME : ""
    };
    sessionStorage.setItem(
      "internalStudentDetails",
      JSON.stringify(studentDetails)
    );
    sessionStorage.setItem("tabName", "completed");

    this.router.navigate(["/exreqdetails"]);
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/completed/completed.component.ts